import {React, useState} from "react";
import './style.scss';

const ThankYouCard = ({ onClose }) => {
  return (
    <div className="tw-flex tw-items-center tw-justify-center tw-p-4">
      <div className="tw-relative tw-w-full tw-max-w-md">
        {/* Main card with curved corner effect */}
        <div className="tw-relative tw-overflow-hidden">
          
          {/* Content */}
          <div className="tw-relative tw-px-8 tw-py-12 tw-flex tw-flex-col tw-items-center tw-text-center">
            {/* Success icon with circle background */}
            <div className="tw-relative tw-mb-8">
              <div className="tw-w-32 tw-h-32 tw-bg-gradient-to-b tw-from-[#159745] tw-to-bg-[#157438] tw-rounded-full tw-flex tw-items-center tw-justify-center">
                
                  <svg 
                    className="tw-w-12 tw-h-12 tw-text-yellow-300" 
                    fill="none" 
                    stroke="currentColor" 
                    viewBox="0 0 24 24"
                  >
                    <path 
                      strokeLinecap="round" 
                      strokeLinejoin="round" 
                      strokeWidth={3} 
                      d="M5 13l4 4L19 7"
                    />
                  </svg>

              </div>
            </div>

            {/* Text content */}
            <h1 className="tw-text-4xl tw-font-bold tw-text-white tw-mb-4">
              Thank you,
            </h1>
            <p className="tw-text-emerald-50 tw-text-lg tw-mb-8 tw-max-w-xs">
              for showing your interest. We will soon get back to you!
            </p>

            {/* Button with skewed shape */}
            {/* <button
              onClick={onClose}
              className="btn-2-white tw-relative hover:tw-scale-105 active:tw-scale-95 tw-shadow-lg hover:tw-shadow-xl"
            >
              <span className="tw-relative tw-z-10"></span>
            </button> */}
          </div>
        </div>

        {/* Subtle shadow effect */}
        <div className="tw-absolute tw-inset-0 tw-bg-emerald-900 tw-opacity-20 tw-rounded-3xl tw-blur-2xl -tw-z-10 tw-transform tw-translate-y-4"></div>
      </div>
    </div>
  );
};

const Contact = () =>{
    
  const [selectedOption, setSelectedOption] = useState("underground");
  const [isSubmitted, setIsSubmitted] = useState(false);

  const options = [
    { id: "underground", label: "BIM/VDC Services" },
    { id: "logistics", label: "Project Engineering Services" }
  ];

  const handleSubmit = (e) => {
    e.preventDefault();
    // Submit form data here if needed
    setIsSubmitted(true);
  };

  const handleThankYouClose = () => {
    setIsSubmitted(false);
    // Reset form if needed
  };

  if (isSubmitted) {
    return (
      <div className="contact-box">
        <div className="contact-inner container">
          <div className="row">
            <div className="col-xl-5 col-lg-6 col-md-12 col-sm-12 col-12 d-flex align-items-center lg:tw-order-1 tw-order-2">
              <div>
                <h2 className="tw-pb-5 sm:tw-pb-10">Let's <br/>Collaborate</h2>
                <h5 className="tw-text-[#FFFB8D] tw-text-[24px] !tw-bold">Contact Information</h5>
                <span className="tw-block tw-text-[18px] !tw-text-white"><a href="#" className="tw-text-[#ffffff]">7900 Westpark Drive McLean, VA 22102</a></span>
                <a href="mailto:Contact@fractilestud.io" className="tw-text-white hover:tw-text-[#FFFB8D]">Contact@fractilestud.io</a>
                <br/>
                <a href="tel:(571)297-1409" className="tw-text-[18px] tw-text-white">(571) 297-1409</a>
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12 col-12 lg:tw-order-2 tw-order-1 d-flex align-items-center justify-content-center">
              <ThankYouCard onClose={handleThankYouClose} />
            </div>
          </div>
        </div>
      </div>
    );
  }

    return(
        <> 
            <div className="contact-box ">
            <div className="contact-inner container">
                <div className="row" >
                    <div className="col-xl-5 col-lg-6 col-md-12 col-sm-12 col-12 d-flex align-items-center lg:tw-order-1 tw-order-2">
                        <div>
                            <h2 className="tw-pb-5 sm:tw-pb-10">Let's <br/>Collaborate</h2>
                            <h5 className="tw-text-[#FFFB8D] tw-text-[24px] !tw-bold">Contact Information</h5>
                            <span className="tw-block tw-text-[18px] !tw-text-white"><a href="#" className="tw-text-[#ffffff]">7900 Westpark Drive McLean, VA 22102</a></span>
                            <a href="mailto:Contact@fractilestud.io" className="tw-text-white hover:tw-text-[#FFFB8D]">Contact@fractilestud.io</a>
                            <br/>
                            <a href="tel:(571)297-1409" className="tw-text-[18px] tw-text-white">(571) 297-1409</a>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-12 col-sm-12 col-12 lg:tw-order-2 tw-order-1">
                        <h4>We'd love to hear from you</h4>
                        <form onSubmit={handleSubmit}>
                            <div className="tw-inline md:tw-flex gap-4">
                            <input type="text" placeholder="First Name" required />
                            <input type="text" placeholder="Last Name" required />
                            </div>
                            <div className="tw-inline md:tw-flex gap-4">
                            <input type="text" placeholder="Company Name" required />
                            <input type="text" placeholder="Subject" required />
                            </div>
                            <div className="tw-inline md:tw-flex gap-4">
                            <input type="tel" placeholder="Phone" required />
                            <input type="text" placeholder="Industry" required />
                            </div>
                            <div className="custom-radio-container">
                                <h3 className="radio-title">Need help with?</h3>

                                <div className="radio-group">
                                    {options.map((option) => (
                                    <div key={option.id} className="radio-wrapper d-flex tw-gap-2">
                                        <input
                                        type="radio"
                                        id={option.id}
                                        name="services"
                                        value={option.id}
                                        checked={selectedOption === option.id}
                                        onChange={(e) => setSelectedOption(e.target.value)}
                                        className="custom-radio-input"
                                        required
                                        />
                                        <label htmlFor={option.id} className="custom-radio-label">
                                        <span className="radio-text">{option.label}</span>
                                        </label>
                                    </div>
                                    ))}
                                </div> 
                            </div> 
                            <button type="submit" className="btn-2-white">Submit</button>
                        </form>
                    </div>
                </div>
            </div>
            </div>
        </>
    )
}

export default Contact;